import { Close } from "@mui/icons-material";
import {
    AppBar,
    Box,
    Button,
    Dialog,
    IconButton,
    List,
    ListItemButton,
    Toolbar,
    Typography,
    Tooltip as Tp,
    TextField,
    Autocomplete,
    MenuItem
} from "@mui/material";
import { getLabels } from "api/services/labels";
import Loader from "components/Loader";
import { useQuery } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { handleApply, resetState, } from "redux/reducers/gstRegisterSlice";
import { ResType } from "types";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { getFilters } from "views/tasks/Filters/getFilters";
import { selectGstRegister } from "redux/reducers/gstRegisterSlice";
import { handleFieldChange } from "redux/reducers/gstRegisterSlice";
import { placeOfSupplyStates } from "data/placeOfSupply";
import useClientCategories from "hooks/useClientCategories";

interface IProps {
    open: boolean;
    setOpen: (open: boolean) => void;
}




function GstReturnsTracker({ open, setOpen }: IProps) {
    const dispatch = useDispatch();
    const states = useSelector(selectGstRegister);
    const {
        categories,
    } = useClientCategories({});
    const applyFilters = () => {
        dispatch(handleApply());
        setOpen(false);
    };

    const handleReset = () => {
        dispatch(resetState());
        setOpen(false);
    };


    let getSubCategories = (): any[] => {
        let result: any[] = [];
        if (!states?.selectedFilters.category?.subCategories) return result;
        result = result.concat(states?.selectedFilters.category?.subCategories);
        return result?.flat();
    };

    interface StatusOption {
        name: string;
        value: string;
    }

    const stateObjects = placeOfSupplyStates.map(state => {
        const value = state.substring(0, 2);
        return { label: state, value: (value) };
    });
    const categoryOptions =
        (categories || []).map(
            (item: any) => ({
                label: item?.name,
                value: item?.id,
                subCategories:
                    item?.subCategories || [],
            }),
        );

    return (
        <Dialog
            sx={{ alignItems: "flex-start", maxHeight: 600 }}
            fullWidth
            maxWidth="sm"
            open={open}
            PaperProps={{
                elevation: 0,
                sx: { display: "flex", flexDirection: "column" },
            }}
        >
            <AppBar
                position="static"
                color="transparent"
                sx={{ boxShadow: "none", borderBottom: "1px solid lightgrey" }}
            >
                <Toolbar sx={{ justifyContent: "space-between", alignItems: "center" }}>
                    <Typography variant="subtitle1">Filters</Typography>
                    <IconButton onClick={() => setOpen(false)}>
                        <Close color="primary" />
                    </IconButton>
                </Toolbar>
            </AppBar>

            <>
                <Box sx={{ overflowY: "auto", mt: 2, pt: 1, px: 2, pb: 4, flex: 1 }}>
                    <Autocomplete
                        id="tags-standard"
                        onChange={(_, value) =>
                            dispatch(
                                handleFieldChange({
                                    key: "category",
                                    value: value || null,
                                }),
                            )
                        }
                        value={states.selectedFilters.category || null}
                        options={categoryOptions || []}
                        sx={{ mt: 3 }}
                        getOptionLabel={(option: any) => option?.label || ''}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                required
                                variant="outlined"
                                size="small"
                                fullWidth
                                label="Client Category"
                            />
                        )}
                    />
                    {/* {getSubCategories().length !== 0 && (
                        <Autocomplete
                            id="tags-standard"
                            multiple
                            onChange={(_, value) => dispatch(handleFieldChange({ key: "subCategory", value: value || [] }))}
                            value={states.selectedFilters.subCategory || []}
                            options={getSubCategories() || []}
                            sx={{ mt: 3 }}
                            getOptionLabel={(option: any) => option?.label}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    required
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    label="Client Sub Category"
                                />
                            )}
                        />
                    )} */}
                    <Autocomplete
                        id="tags-standard"
                        onChange={(_, value) => dispatch(handleFieldChange({ key: "jurisdiction", value: value || [] }))}
                        value={
                            states.selectedFilters
                                .jurisdiction || null
                        }
                        options={stateObjects || []}
                        sx={{ mt: 3 }}
                        getOptionLabel={(option: any) => option?.label || ''}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                required
                                variant="outlined"
                                size="small"
                                fullWidth
                                label="State Jurisdiction"
                            />
                        )}
                    />


                    <Autocomplete
                        id="tags-standard"
                        multiple
                        options={[{ label: "Filed", value: "Filed" }, { label: "Not Filed", value: "Not Filed" }, { label: "Not Required", value: "No data" }]}
                        getOptionLabel={(option) => option.label || ""}
                        onChange={(_, value) =>
                            dispatch(handleFieldChange({ key: "status", value: value || [] }))
                        }
                        value={states?.selectedFilters?.status || []}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Return Status"
                                variant="outlined"
                                size="small"
                                fullWidth
                                sx={{ mt: 3 }}
                            />
                        )}
                        fullWidth
                        size="small"
                    />
                </Box>
            </>
            <AppBar
                position="static"
                color="transparent"
                sx={{ boxShadow: "none", borderTop: "1px solid lightgrey" }}
            >
                <Toolbar sx={{ justifyContent: "flex-end", gap: 2, alignItems: "center" }}>
                    <Button onClick={handleReset} variant="outlined" color="secondary">
                        Reset
                    </Button>
                    <Button onClick={applyFilters} variant="contained" color="secondary">
                        Apply
                    </Button>
                </Toolbar>
            </AppBar>
        </Dialog>
    );
}

export default GstReturnsTracker;